
const PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA = 10

const PROVIDERS = {
  instagram: {
    channels: ['instagram'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 2000 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithButtons: 640 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithImageAndButtons: 80 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
      },
    },
    acceptTypes: {
      chat: 'image/*,video/mp4',
      marketing: 'image/*',
    },
    toolbar: [],
  },
  facebook: {
    channels: ['facebook'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 2000 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithButtons: 640 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithImageAndButtons: 80 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
      },
    },
    acceptTypes: {
      chat: 'image/*,video/mp4',
      marketing: 'image/*',
    },
    toolbar: [],
  },
  telegram: {
    channels: ['telegram'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 4096 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithFiles: 1024,
      },
    },
    acceptTypes: {
      chat: 'image/*,video/mp4,application/pdf',
      marketing: 'image/*,video/mp4,application/pdf',
    },
    toolbar: [['bold', 'italic', 'link']],
  },
  twilio: {
    channels: ['sms', 'whatsapp'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 1024 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
      },
    },
    acceptTypes: {
      chat: 'image/jpg,image/jpeg,image/png,video/mp4,application/pdf',
      marketing: 'image/jpg,image/jpeg,image/png,video/mp4,application/pdf',
    },
    toolbar: {
      whatsapp: [['bold', 'italic']],
      sms: [],
    },
    files: {
      size: {
        sms: 5242880 //5MB
      },
      label: {
        sms: 'campaigns_label_size_sms'
      }
    },
    errors: {
      sms: {
        size: 'campaigns_error_size_sms'
      },
    },
  },
  chatmail: {
    channels: ['chatmail'],
    validation: {
      name: {
        required: true
      },
      subject: {
        required: true
      },
      content: {
        required: true
      }
    },
    acceptTypes: {
      chat: 'image/*,video/mp4',
      marketing: 'image/*,video/mp4'
    },
    toolbar: []
  },
  wall: {
    channels: ['chatweb', 'ios', 'android'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 4096 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
        limitWithFiles: 1024,
      },
    },
    acceptTypes: {
      chat: 'image/*,video/mp4,application/pdf',
      marketing: 'image/*,video/mp4,application/pdf',
    },
    toolbar: [['bold', 'italic', 'link']],
  },
  whatsapp: {
    channels: ['whatsapp_whatsapp'],
    validation: {
      name: {
        required: true,
      },
      content: {
        required: true,
        limit: 1024 - PROVIDERS_CONTENT_VALIDATION_LIMIT_EXTRA,
      },
    },
    acceptTypes: {
      chat: 'image/jpg,image/jpeg,image/png,video/mp4,application/pdf',
      marketing: 'image/jpg,image/jpeg,image/png,video/mp4,application/pdf',
    },
    toolbar: {
      whatsapp: [['bold', 'italic']],
      sms: [],
    },
    files: {
      size: {
        sms: 5242880 //5MB
      },
      label: {
        sms: 'campaigns_label_size_sms'
      }
    },
    errors: {
      sms: {
        size: 'campaigns_error_size_sms'
      },
    },
  },
}

const CHANNELS = {
  chatmail: 'chatmail',
  chatweb: 'chatweb',
  whatsapp: 'whatsapp',
  sms: 'sms',
  facebook: 'facebook',
  instagram: 'instagram',
  telegram: 'telegram',
  android: 'android',
  ios: 'ios',
  wall: 'wall',
  whatsapp_whatsapp: 'whatsapp_whatsapp'
}

const status = {
  DRAFT: 'status_DRAFT',
  SCHEDULED: 'status_SCHEDULED',
  IN_PROGRESS: 'status_IN_PROGRESS',
  SENT: 'status_SENT',
  FINISHED: 'status_FINISHED',
}

const STATUS_FROM_FACEBOOK = {
  IN_PROCESS: 'IN_PROCESS',
  PAUSED: 'PAUSED',
  ACTIVE: 'ACTIVE',
  WITH_ISSUES: 'WITH_ISSUES',
}

const channelsInFilters = {
  sms: 'SMS',
  whatsapp: 'WA',
  whatsapp_24: 'WA24',
  telegram: 'TG',
  instagram: 'IG',
  instagram_24: 'IG24',
  facebook: 'FB',
  facebook_24: 'FB24',
  ios: 'IOS',
  android: 'AND',
  wall: 'MUR',
  chatweb: 'CHW',
  chatweb_api: 'CHWAPI',
  android_api: 'ANDAPI',
  ios_api: 'IOSAPI',
}
const channelsForFilters = {
  sms: 'sms',
  whatsapp: 'whatsapp',
  whatsapp_24: 'whatsapp_24',
  telegram: 'telegram',
  instagram: 'instagram',
  instagram_24: 'instagram_24',
  facebook: 'facebook',
  facebook_24: 'facebook_24',
  ios: 'ios',
  android: 'android',
  wall: 'muro',
}
const sortInit = {
  sortType: 'desc',
  sortByField: 'createdAt',
}
const colsToShowInit = [
  'name',
  'createdAt',
  'startDate',
  'endDate',
  'state',
  'createdByName',
  'durationTime'
]
const urlsTwillo = {
  templates: 'https://www.twilio.com/console/sms/whatsapp/templates',
  submit: 'https://www.twilio.com/console/sms/whatsapp/templates/submit',
  tutorial: 'https://www.twilio.com/docs/whatsapp/tutorial/send-whatsapp-notification-messages-templates',
}

const colsShowCampaign = [
  { value: 'name', key: 'campaign_listing_name',isSelected: false, },
  { value: 'createdAt', key: 'campaign_listing_createdAt', isSelected: false },
  { value: 'startDate', key: 'campaign_listing_startDate', isSelected: false },
  { value: 'endDate', key: 'campaign_listing_endDate', isSelected: false },
  { value: 'state', key: 'campaign_listing_state', isSelected: false },
  { value: 'createdByName', key: 'campaign_listing_createdByName', isSelected: false },
  { value: 'durationTime', key: 'campaign_listing_duration', isSelected: false },
  { value: 'cost', key: 'campaign_listing_cost', isSelected: false },
  { value: 'channelsInFilters', key: 'campaign_listing_channel', isSelected: false },
  { value: 'totalUsers', key: 'campaign_listing_users', isSelected: false }
]

// new design search
const searchFilterCampaign = [
  'textToSearch',
  'name',
  'limit',
  'states',
  'channels',
  'operators',
  'createdAt',
  'startDate',
  'endDate'
]

const numbersPerPage = [
  { value: 30, label: '30' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
]

const fieldsFiltersCampaign = {
  textToSearch:{
    label:'textToSearch',
    name:'textToSearch',
    default:'',
    type:'text',
    placeholder:'dashboard_search',
    className:'icon-placeholder',
    divider: false
  },
  limit:{
    type: 'select_one',
    name: 'limit',
    label: 'dashboard_show',
    default: 30,
    options: numbersPerPage.map((elem) => ({ value: elem.value, label: elem.label })),
    divider: true
  },
  name:{
    label:'name',
    name:'name',
    default:'',
    type:'text',
    placeholder:'dashboard_campaign-name',
    className:'icon-placeholder',
    divider: false
  },
  states:{
    label:'dashboard_state',
    name:'states',
    default:[],
    type:'select_one_many',
    placeholder:'',
    divider: false
  },
  channels:{
    label:'dashboard_channels',
    name:'channels',
    default:[],
    type:'select_one_many',
    placeholder:'',
    divider: false
  },
  operators:{
    label:'campaign_listing_createdByName',
    name:'operators',
    default:[],
    type:'select_one_many',
    placeholder:'',
    divider: true
  },
  createdAt:{
    name:'createdAt',
    subtitle:'dashboard_select-date-range',
    type:'date',
    default:['', ''],
    divider: false,
    label:'dashboard_creation-date',
  },
  startDate:{
    name:'startDate',
    subtitle:'dashboard_select-date-range',
    type:'date',
    default:['', ''],
    divider: false,
    label:'dashboard_start-date',
  },
  endDate:{
    name:'endDate',
    subtitle:'dashboard_select-date-range',
    type:'date',
    default:['', ''],
    divider: false,
    label:'dashboard_finish-date',
  },
  page:{
    default: 0
  },
  sortByField:{
    default: sortInit.sortByField
  },
  sortType:{
    default: sortInit.sortType
  }
}

export default {
  providers: PROVIDERS,
  channels: CHANNELS,
  status,
  statusFromFacebook: STATUS_FROM_FACEBOOK,
  channelsInFilters,
  channelsForFilters,
  sortInit,
  colsToShowInit,
  urlsTwillo,
  searchFilterCampaign,
  numbersPerPage,
  fieldsFiltersCampaign,
  colsShowCampaign
}
